import { render } from "./FeedbackWindow.vue?vue&type=template&id=63bb2e91&scoped=true"
import script from "./FeedbackWindow.vue?vue&type=script&lang=js"
export * from "./FeedbackWindow.vue?vue&type=script&lang=js"

import "./FeedbackWindow.vue?vue&type=style&index=0&id=63bb2e91&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bb2e91"]])

export default __exports__